module.exports = __webpack_public_path__ + "assets/img/1dcdcb1849b37e835e2cf5089c61de4d.svg";